import React from 'react';
import Icon from "../../Atoms/Icon";
import CompanyItem from "../../Atoms/Items/CompanyItem";

const SidebarHeader = () => {

  return (
    <header className="cursor-pointer select-none s-mb-16px s-px-12px s-py-8px hover-change normal-radius">
      <div className="s-cross-center nowrap">
        <CompanyItem
          className="s-w-full"
          data-testid="session-data"
          src="https://cdn.svgporn.com/logos/discord-icon.svg"
          companyName="Discord"
        />
        <Icon
          className="s-to-right flex-none"
          svg="double-arrow"
          size="1rem"
        />
      </div>
    </header>
  );
};

export default SidebarHeader;
